// ABOUTME: Main PhotoStream React application with authentication and navigation integration
// ABOUTME: Implements routing structure with AuthProvider and consistent Layout component

import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AuthErrorBoundary } from './components/auth/AuthErrorBoundary';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { GalleryPage } from './pages/GalleryPage';
import { UploadPage } from './pages/UploadPage';
import { PhotoDetailPage } from './pages/PhotoDetailPage';
import { AdminPage } from './pages/AdminPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { Hub } from 'aws-amplify/utils';

// Auth callback component that handles OAuth response
const AuthCallback: React.FC = () => {
  React.useEffect(() => {
    // Listen for auth events
    const unsubscribe = Hub.listen('auth', ({ payload }) => {
      console.log('Auth event:', payload);
      if (payload.event === 'signedIn') {
        console.log('Sign in successful, redirecting...');
        window.location.href = '/';
      }
    });

    return unsubscribe;
  }, []);

  return <div>Processing authentication...</div>;
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout><HomePage /></Layout>,
  },
  {
    path: "/auth/callback",
    element: <AuthCallback />,
  },
  {
    path: "/gallery/:id",
    element: <Layout><GalleryPage /></Layout>,
  },
  {
    path: "/gallery/:id/upload",
    element: <Layout><UploadPage /></Layout>,
  },
  {
    path: "/gallery/:id/photo/:photoId",
    element: <Layout><PhotoDetailPage /></Layout>,
  },
  {
    path: "/admin",
    element: <Layout><AdminPage /></Layout>,
  },
  {
    path: "*",
    element: <Layout><NotFoundPage /></Layout>,
  },
]);

function App() {
  return (
    <AuthErrorBoundary>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </AuthErrorBoundary>
  );
}

export default App;
